module.exports = __webpack_public_path__ + "static/b4-2213b7899ea62633368235f2ca17566f.jpg";